import update from 'immutability-helper';
import { SET_NEW_SHOPPINGCART } from './actionTypeConsts.js';

// ------------------------------------
// Constants
// ------------------------------------

export const CHECKOUT_CHANGE_SELECTED_SHIPMENT_TYPE = 'CHECKOUT/CHANGE_SELECTED_SHIPMENT_TYPE';
export const CHECKOUT_CHANGE_SELECTED_PAYMENT_TYPE = 'CHECKOUT/CHANGE_SELECTED_PAYMENT_TYPE';
export const CHECKOUT_CHANGE_ORDER_COMMENT = 'CHECKOUT/CHANGE_ORDER_COMMENT'

export function checkoutChangeSelectedShipmentType(shipmentType) {
	return {
		type: CHECKOUT_CHANGE_SELECTED_SHIPMENT_TYPE,
		shipmentType,
	};
}

export function checkoutChangeSelectedPaymentType(paymentType) {
	return {
		type: CHECKOUT_CHANGE_SELECTED_PAYMENT_TYPE,
		paymentType,
	};
}

export function checkoutChangeOrderComment(orderComment) {
	return {
		type: CHECKOUT_CHANGE_ORDER_COMMENT,
		orderComment
	}
}

// ------------------------------------
// Helpers
// ------------------------------------
export function determineDefaultOrSelectedAvailableShipmentType() {
	return async (dispatch, getState) => {
		const merchantId = getState().merchant.merchantId;
		const shoppingCart = getState().shoppingCart.elements[merchantId];
		const defaultOrSelectedShipmentType = getState().checkoutPage?.selectedShipmentType || getState().bookingOffice?.defaultShipmentType || null;
		const availableShipmentTypesForShoppingCart = Object.assign([], shoppingCart?.shipmentTypes?.shipmentTypes).sort();
		if(availableShipmentTypesForShoppingCart.length > 0){
			const selectedShipmentType = availableShipmentTypesForShoppingCart.find(shipmentType => shipmentType === defaultOrSelectedShipmentType) ?
				defaultOrSelectedShipmentType :
				availableShipmentTypesForShoppingCart[0];
			return dispatch(checkoutChangeSelectedShipmentType(selectedShipmentType));
		}
	};
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
	selectedShipmentType: '',
	selectedPaymentType: '',
	orderComment: '',
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[CHECKOUT_CHANGE_SELECTED_SHIPMENT_TYPE]: (state, action) => update(state, {
		selectedShipmentType: { $set: action.shipmentType },
	}),
	[SET_NEW_SHOPPINGCART]: (state) => update(state, {
		selectedShipmentType: { $set: initialState.selectedShipmentType },
		orderComment: {$set: initialState.orderComment}
	}),
	[CHECKOUT_CHANGE_SELECTED_PAYMENT_TYPE]: (state, action) => update(state, {
		selectedPaymentType: { $set: action.paymentType },
	}),
	[CHECKOUT_CHANGE_ORDER_COMMENT]: (state, action) => update(state, {
		orderComment: { $set: action.orderComment },
	}),
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
